import { Network } from ':fat/core/networks';
import { reconstructTransactions } from ':fat/workers/blockchain/transactions/reconstruct';
import { Transaction } from ':fat/workers/blockchain/types';

// These messages are the ones that can be sent to the security frame
export type Message =
  | { kind: 'SANITY_CHECK' }
  | { kind: 'PING' }
  | { kind: 'PONG' }
  | { kind: 'SET_DEVTOOL_STATE'; state: typeof window.DEVTOOL_STATE }
  | { kind: 'GO_TO_FIRST_PAGE' }
  | { kind: 'XPUBS_SAVED' }
  | { kind: 'XPUB_SAVE_ERROR'; error: string }
  | { kind: 'REQUEST_TRANSACTION_SIGNING'; txs: Record<Network, Transaction[]> };

export function goToFirstPage() {
  void MessageBus.send('securityFrame', { kind: 'GO_TO_FIRST_PAGE' });
}

export async function sanityCheck() {
  return MessageBus.send(
    'securityFrame',
    { kind: 'SANITY_CHECK' },
    { expectReply: 'SANITY_CHECK_RESPONSE' },
  );
}

export async function ping() {
  return MessageBus.send('securityFrame', { kind: 'PING' }, { expectReply: 'PONG' });
}

export async function signTransactions(txs: Record<Network, Transaction[]>) {
  const { signedTxs } = await MessageBus.send(
    'securityFrame',
    { kind: 'REQUEST_TRANSACTION_SIGNING', txs },
    { expectReply: 'SIGNED_TRANSACTIONS' },
  );

  return reconstructTransactions(signedTxs);
}
